module.exports = __webpack_public_path__ + "static/media/BME.b2f4c9c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/images/logo/BME.png
// module id = 958
// module chunks = 0